export const polarToCartesian = (centerX, centerY, radius, angleInDegrees) => {
  const angleInRadians = ((angleInDegrees - 180) * Math.PI) / 180.0;

  return {
    x: centerX + radius * Math.cos(angleInRadians),
    y: centerY + radius * Math.sin(angleInRadians),
  };
};

export const describeArc = (x, y, radius, startAngle, endAngle) => {
  const start = polarToCartesian(x, y, radius, endAngle);
  const end = polarToCartesian(x, y, radius, startAngle);
  const largeArcFlag = endAngle - startAngle <= 180 ? '0' : '1';

  return `M ${start.x} ${start.y} A ${radius} ${radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y}`;
};

export const getHeatColor = (quantidade, maxQuantidade) => {
  if (!quantidade) return '#e5e7eb';
  if (maxQuantidade <= 1) return '#8dde95';

  const intensidade = quantidade / maxQuantidade;
  if (intensidade >= 0.75) return '#0f7a2f';
  if (intensidade >= 0.5) return '#1fa247';
  if (intensidade >= 0.25) return '#56c667';
  return '#9be39f';
};

export const buildHeatmapColumns = dias => {
  if (!Array.isArray(dias) || dias.length === 0) {
    return [];
  }

  const normalizedDays = dias.map(item => {
    const [year, month, day] = String(item?.data || '').split('-').map(Number);
    const date = new Date(year, (month || 1) - 1, day || 1);

    return {
      data: item?.data || '',
      quantidade: Number(item?.quantidade || 0),
      date,
      monthLabel: date.toLocaleDateString('pt-BR', { month: 'short' }).replace('.', ''),
      weekday: date.getDay(),
      dayLabel: date.toLocaleDateString('pt-BR'),
    };
  });

  const firstDate = normalizedDays[0]?.date;
  if (!firstDate) return [];

  const firstColumnOffset = firstDate.getDay();
  const placeholders = Array.from({ length: firstColumnOffset }, (_, index) => ({
    id: `placeholder-${index}`,
    empty: true,
    weekday: index,
  }));

  const allItems = [...placeholders, ...normalizedDays];
  const columns = [];
  let previousMonthKey = '';

  for (let index = 0; index < allItems.length; index += 7) {
    const items = allItems.slice(index, index + 7);
    const firstRealItem = items.find(item => !item.empty);
    const monthKey = firstRealItem
      ? `${firstRealItem.date.getFullYear()}-${firstRealItem.date.getMonth()}`
      : '';

    columns.push({
      id: `week-${index / 7}`,
      monthLabel: monthKey && monthKey !== previousMonthKey ? firstRealItem.monthLabel : '',
      items,
    });

    if (monthKey) {
      previousMonthKey = monthKey;
    }
  }

  return columns;
};
